import { useEffect, useRef, useState } from 'react';
import BreadCrumb from '../../../component/BreadCrumb';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import { VIEW_SYSTEM_ENROLMENT_NOTICE } from '../../../constant/ViewConstant';
import CodeUtil from '../../../util/CodeUtil';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import { useDispatch, useSelector } from 'react-redux';
import SelectionBox from '../../../component/SelectionBox';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import TextEditor from '../../../component/editor/TextEditor';
import PopupRef from '../../../component/PopupRef';
import SemesterUtil from '../../../util/SemesterUtil';
import { BlueBorderButtonBox } from '../../../component/buttons/CustomButtonBox';
import {
    actionSearch,
    handleSemesterId,
    actionSaveNotice,
} from '../../../module/body/semester/SemesterEnrolmentManagementModule';

const ConditionArea = () => {
    const [semesterId, setSemesterId] = useState('');
    const [mainUniversityCd, setMainUniversityCd] = useState('COMMON');
    const dispatch = useDispatch();

    useEffect(() => {
        setSemesterId(SessionStorageUtil.getCurrentSemesterId());
    }, []);

    useEffect(() => {
        if (semesterId) {
            dispatch(
                actionSearch({
                    params: {
                        semesterId,
                        mainUniversityCd,
                    },
                }),
            );
        }

        dispatch(handleSemesterId(semesterId));
    }, [semesterId]);

    const onClickSearch = () => {
        dispatch(
            actionSearch({
                params: {
                    semesterId,
                    mainUniversityCd,
                },
            }),
        );
        console.log(mainUniversityCd);
    };

    const handleChangeSemeterId = (semesterId) => {
        setSemesterId(semesterId);
        dispatch(handleSemesterId(semesterId));
    };

    return (
        <>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => handleChangeSemeterId(e.target.value)}
                                    useAll={false}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox title='조회' onClick={onClickSearch} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const NoticeArea = () => {
    const { semesterInfo, semesterId } = useSelector((state) => state.semesterEnrolmentManagementState);
    const [mainUniversityCd, setMainUniversityCd] = useState('COMMON');

    const [enrolmentNotice, setEnrolmentNotice] = useState('');

    const dispatch = useDispatch();

    const popupRef = useRef(null);

    useEffect(() => {
        setEnrolmentNotice(semesterInfo?.enrolmentNotice);
    }, [semesterInfo]);

    const handleConfirm = () => {
        dispatch(
            actionSaveNotice({
                params: {
                    semesterId,
                    mainUniversityCd,
                    enrolmentNotice,
                    enrolmentNoticeStatusCd: 'ENABLED',
                },
                callback: () => {
                    popupRef.current.openInfo('수강신청 유의사항이 저장 되었습니다.', () => {
                        return function () {};
                    });
                },
            }),
        );
    };

    return (
        <>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3>
                        공통 수강신청 유의사항 관리 {semesterId && `(${SemesterUtil.convertSemesterNm(semesterId)})`}
                    </h3>
                </div>
                <div className='comment-box'>
                    <ul>
                        <li> 해당학기의 수강신청 유의사항 내용을 작성합니다.</li>
                    </ul>
                </div>
                <TextEditor
                    className='cmnty-wrt-box mt16'
                    value={enrolmentNotice ? enrolmentNotice : ''}
                    onChange={setEnrolmentNotice}
                />
                <div className='right-btn-box btn-wrap'>
                    <BlueBorderButtonBox title='저장' onClick={(e) => handleConfirm(e)} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

const SystemEnrolmentNoticeView = () => {
    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg03'>
                    <h2 className='con-title'>{VIEW_SYSTEM_ENROLMENT_NOTICE.title}</h2>
                    <p className='con-title-p'>{VIEW_SYSTEM_ENROLMENT_NOTICE.subTitle}</p>
                </div>
                <div className='sub-nav-wrap '>
                    <div className='sub-nav-box'>
                        <BreadCrumb />
                    </div>
                </div>

                <ConditionArea />
                <NoticeArea />
            </div>
        </section>
    );
};

export default SystemEnrolmentNoticeView;
